<template>
    <modal ref="modalRechazarAnuncio" titulo="" tamano="modal-lg">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-10">
                    <img src="/img/pruebas/anuncio1.png" alt="" class="w-100">
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
export default {
    data(){
        return{
            inputComentario:'',
        }
    },
    methods:{
        toggle(){
            this.$refs.modalRechazarAnuncio.toggle()
        },
        guardarValores(){
            this.$refs.modalRechazarAnuncio.toggle()
        }
    }
}
</script>
<style lang="scss" scoped>

</style>